export enum PerfilUsuario {
  ABRAPA = "ABRAPA",
  CERTIFICADORA = "CERTIFICADORA",
  ESTADUAL = "ESTADUAL",
  PRODUTOR = "RESPONSAVEL_ABR",
  BCI = "BCI",
  RESPONSAVEL_ABR = "RESPONSAVEL_ABR",
  CERTIFICADORA_AUDITOR = "CERTIFICADORA_AUDITOR",
}
